import React from 'react'
import Home from '../components/home/Home.tsx'
import { Text } from '../components/text/Text.tsx'

const HomePage = () => {
    return (
        <div >
            <Home />
        </div>
    )
}

export default HomePage